import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  publishDate: string;
  imageUrl: string;
  isHot?: boolean;
  isExclusive?: boolean;
  viewCount?: number;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  publishDate,
  imageUrl,
  isHot,
  isExclusive,
  viewCount,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-200 rounded-2xl overflow-hidden transition-all duration-300 hover:translate-y-[-4px] hover:ring-2 hover:ring-primary-500/30 cursor-pointer"
    >
      <div className="relative w-full h-52 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 爆料网独家揭秘`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent"></div>
        <div className="absolute top-3 right-3 flex gap-2">
          {isHot && (
            <span className="bg-primary-500 text-background-50 text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap">
              热
            </span>
          )}
          {isExclusive && (
            <span className="bg-accent-500 text-background-50 text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap">
              独家
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-foreground-950 text-base font-bold leading-snug line-clamp-2 mb-2 group-hover:text-primary-400 transition-colors duration-200">
            {title}
          </h3>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <Link
              to={`/category/${category}`}
              className="text-primary-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap"
              onClick={(e) => e.stopPropagation()}
            >
              {categoryName}
            </Link>
            <span>|</span>
            <span>{publishDate}</span>
            {viewCount !== undefined && (
              <>
                <span>|</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {viewCount > 10000
                    ? `${(viewCount / 10000).toFixed(1)}万`
                    : viewCount}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}